import * as React from 'react';
import {Pagination} from 'antd';
import {useState} from "react";



export interface PaginationParams {
    offset: number;
    count : number;
}

export const PaginationDefaultParams:PaginationParams = {
    offset: 0,
    count : 20
};

interface PaginatorProps {
    size?: string;
    total : number;
    onChangePageCallback: (params:PaginationParams)=>void;
    defaultPageSize?:number
}

/**
 * This Class handles pagination in all pages
 * @param props
 * @constructor
 */
const Paginator:React.FC<PaginatorProps> = props => {
    const {size=`small`, total, defaultPageSize=10, onChangePageCallback} = props;
    const [currentPage, setCurrentPage] = useState(1);

    const onChange = (page:number, pageSize:number=defaultPageSize):void => {
        setCurrentPage(page);
        onChangePageCallback({
            offset: (page - 1) * pageSize,
            count : pageSize
        })
    };

    return(
        <Pagination size={size}
                    current={currentPage}
                    total={total}
                    defaultPageSize={defaultPageSize}
                    showTotal={() => {
                        return `تعداد کل: ${total}`; //TODO should be translate dynamically
                    }}
                    onChange={onChange}
        />

    )

};

export default Paginator